import { motion } from "framer-motion";

export default function Footer({ basePath = "" }) {
  return (
    <footer data-testid="site-footer" className="relative bg-[var(--charcoal)] text-[var(--cream)] grain overflow-hidden">
      <div className="beam-glow pointer-events-none absolute inset-0 opacity-50" />
      <div className="container-luxe relative z-10 py-20 lg:py-28">
        <motion.a
          href={`${basePath}#contact`}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="block serif leading-none tracking-tight text-[clamp(3rem,12vw,10rem)] text-[var(--cream)] hover:text-[var(--gold-soft)] transition-colors duration-500"
          data-testid="footer-cta"
        >
          Let's Talk<span className="gold-shimmer">.</span>
        </motion.a>

        <div className="mt-16 grid md:grid-cols-3 gap-10 border-t border-white/12 pt-12">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="serif text-2xl">Beam</span>
              <span className="serif text-2xl gold-shimmer">Concierge</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[var(--cream)]/60">
              Hospitality-grade reputation management. A proud division of Empress
              Collective &amp; Company.
            </p>
          </div>

          <div>
            <p className="overline text-[var(--gold-soft)]">Explore</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              {["Mission", "Services", "Process", "Pricing", "Contact"].map((l) => (
                <li key={l}>
                  <a
                    href={`${basePath}#${l.toLowerCase()}`}
                    className="text-[var(--cream)]/75 hover:text-[var(--gold-soft)] transition-colors duration-300"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="overline text-[var(--gold-soft)]">Get in Touch</p>
            <a
              href="mailto:Contactus@beamconcierge.com"
              className="mt-4 block text-sm text-[var(--cream)]/85 hover:text-[var(--gold-soft)] transition-colors duration-300"
            >
              Contactus@beamconcierge.com
            </a>
            <p className="mt-2 text-sm text-[var(--cream)]/60">Charlotte, NC</p>
            <p className="text-sm text-[var(--cream)]/60">Serving businesses anywhere in the U.S.</p>
          </div>
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/12 pt-8 text-xs text-[var(--cream)]/45">
          <p>© {new Date().getFullYear()} Beam Concierge. All rights reserved.</p>
          <p className="uppercase tracking-[0.2em]">Shining bright, like the sun.</p>
        </div>
      </div>
    </footer>
  );
}
